import { FieldType } from "../api.js";
const ReferralCommissionSettingsSpec = {
  minComAmt: FieldType.Number,
  minDepAmt: FieldType.Number
};
const ReferralTxModelSpec = {
  level: FieldType.Number,
  date: FieldType.DateTime,
  claimedAt: FieldType.DateTime,
  amount: FieldType.BigNumber,
  turnover: FieldType.BigNumber
};
const ReferralOverallSpec = {
  income: {
    todayIncome: FieldType.BigNumber,
    ytdIncome: FieldType.BigNumber,
    lifeTime: FieldType.BigNumber
  },
  directReferral: {
    todayRegistration: FieldType.Number,
    ytdRegistration: FieldType.Number,
    lifeTimeRegistration: FieldType.Number,
    todayFTD: FieldType.Number,
    ytdFTD: FieldType.Number,
    lifeTimeFTD: FieldType.Number
  },
  teamReferral: {
    todayRegistration: FieldType.Number,
    ytdRegistration: FieldType.Number,
    lifeTimeRegistration: FieldType.Number,
    todayFTD: FieldType.Number,
    ytdFTD: FieldType.Number,
    lifeTimeFTD: FieldType.Number
  }
};
export {
  ReferralCommissionSettingsSpec,
  ReferralOverallSpec,
  ReferralTxModelSpec
};
